"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckAvailbilityResponseMapper = void 0;
var CheckAvailbilityResponseMapper = /** @class */ (function () {
    function CheckAvailbilityResponseMapper(data) {
        this.localData = data;
    }
    CheckAvailbilityResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return CheckAvailbilityResponseMapper;
}());
exports.CheckAvailbilityResponseMapper = CheckAvailbilityResponseMapper;
//# sourceMappingURL=CheckAvailbilityResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/CheckAvailbilityResponseMapper.js
// module id = 2076
// module chunks = 8